import { get, post, put, upload, del } from 'api/axiosApi';
import { env } from 'utils/env';
import { objToQueryString } from 'utils/functions';

const url = env.REACT_APP_LEASING_API_URL; //"http://kube-w1:32751/api";
const masterPartnerUrl = env.REACT_APP_LSNG_MASTERPARTNER_API_URL;

export function updateOfferClientData(client) {
  return put(url + `/leasingoffers/${client.documentId}/${client.siteId}/client/${client.partnerId}`, client);
}

export function updateOfferAssociatedPartnerData(associatedPartner) {
  return post(url + `/leasingoffers/${associatedPartner.documentId}/${associatedPartner.siteId}/associatedpartner`, associatedPartner);
}

export function getDefaultOCRFileExtensions() {
  return get(`${url}/leasingoffers/ocr-file-extensions`);
}

export function uploadOCRFile(documentId, siteId, partnerId, formData, progressCallback) {
  return upload(`${url}/leasingoffers/${documentId}/${siteId}/${partnerId}/uploadOCRFile`, formData, progressCallback);
}

export function getPartnerTypes() {
  return get(url + '/partnertypes/');
}

export function getIdTypes() {
  return get(url + '/idtypes/');
}

export function getPartnerRoles(documentTypeId) {
  return get(url + `/partnerroles/${documentTypeId}`);
}

export function getCountries(search) {
  return get(url + '/countries/' + (search || ''));
}

export function getCitizenships(search) {
  return get(url + '/citizenships/' + (search || ''));
}

export function getRelations(search) {
  return get(url + '/relations/' + (search || ''));
}

export function getCounties(search, parentId) {
  return get(`${url}/counties?` + objToQueryString({ parentId, search: search || '' }));
}

export function getCities(search, countyId) {
  return get(`${url}/cities?` + objToQueryString({ countyId: countyId || 0, search }));
}

export function getGDPR() {
  return get(`${url}/gdpr`);
}

export function getClient(documentId, siteId, uniqueId, partnerTypeId, isExternal) {
  return get(`${url}/partners/${documentId}/${siteId}/${partnerTypeId}/${uniqueId}?isExternal=${!!isExternal}`);
}

export function getPartnerNationalityId(uniqueId, isExternal) {
  return get(`${url}/partners/getNationalityId/${uniqueId}?isExternal=${!!isExternal}`);
}

export function getDefaultPartnerAddress(partnerTypeId) {
  return get(`${url}/partners/default-address/${partnerTypeId}`);
}

export function printGDPR(documentId, siteId, partnerId) {
  return post(url + `/leasingoffers/${documentId}/${siteId}/gdpr/print`, {
    documentId: documentId,
    siteId: siteId,
    partnerId: partnerId
  });
}

export function getCompanyInformation(uniqueId, partnerTypeId) {
  return post(`${url}/leasingoffers/getCompanyInformation/uniqueId`, { uniqueId, partnerTypeId });
}

//
// Associated Partner

export function loadAssociatedPartner(documentId, siteId, partnerId) {
  return get(`${url}/leasingoffers/${documentId}/${siteId}/associatedpartner/${partnerId}`);
}

export function deleteAssociatedPartner(data) {
  return del(url + `/leasingoffers/${data.documentId}/${data.siteId}/deleteassociatedpartner/`, data);
}

export function deleteDocumentPartner(data) {
  return del(url + `/leasingoffers/${data.documentId}/${data.siteId}/deletedocumentpartner/`, data);
}

export function loadPFPartners(filters) {
  const qs = objToQueryString({ ...filters });
  return get(`${masterPartnerUrl}/partners/individuals?${qs}`);
}

export function loadLegalPartners(filters) {
  const qs = objToQueryString({ ...filters });
  return get(`${masterPartnerUrl}/partners/legal-partners?${qs}`);
}

export function getPartnerHierarchy(parentId) {
  return get(`${url}/partners/partners-from-hierarchy/${parentId}`);
}

export function savePartnerHierarchy(documentId, siteId, parentGroupId, addedPartners) {
  return put(`${url}/partners/${documentId}/${siteId}/add-partners-from-hierarchy`, {
    documentId,
    siteId,
    parentGroupId,
    addedPartners
  });
}
